<template>
  <Card
    :title="tariffInformation.title ?? ''"
    :dockedPosition="dockedPosition"
    :footerDivider="false"
    :headerDivider="false"
    :background-color-card="true"
  >
    <template v-slot:content>
      <Card class="white tariff-alert">
        <template #content>
          <div class="tariff-row">
            <div class="tariff-col-left">
              <div class="tariff-text">
                {{
                  $t('tariffInformationTile.title', {
                    tariff: tariffInformation.tariff,
                    comprehension: tariffInformation.comprehensionAsString
                  })
                }}
              </div>
              <br />
              <div class="tariff-text">
                {{ $t('tariffInformationTile.helpTextFormerInsurance') }}
              </div>
            </div>
            <div v-if="tariffInformation.formattedPrice" class="tariff-col-price">
              <h2 class="tariff-text-price">
                {{ tariffInformation.formattedPrice }}
              </h2>
            </div>
          </div>
        </template>
      </Card>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { type PropType } from 'vue'
import { type TariffInformation } from '@/typesTenant/NewVehicleDetailApi'
import { Card } from 'de-zurich-ui-library'

defineProps({
  dockedPosition: {
    type: String,
    default: 'false'
  },
  tariffInformation: {
    type: Object as PropType<TariffInformation>,
    required: true
  }
})
</script>

<style scoped lang="scss">
.alert.white {
  background-color: white !important;
}

// Ui Lib Fix
.alert > .text {
  color: var(--alert-font-color);
  font-family: var(--f-primary-bold);
  font-size: var(--base-font-size);
  line-height: 26px;
}

/* Two-column layout within Alert */
.tariff-alert .tariff-row {
  display: flex;
  width: 100%;
  gap: 16px;
  align-items: stretch; /* allow columns to take full height so price can bottom align */
}

.tariff-alert .tariff-col-left {
  flex: 1 1 auto;
  min-width: 0; /* allow text wrapping */
}

.tariff-alert .tariff-col-price {
  flex: 0 0 auto; /* shrink to content */
  display: flex;
  align-items: flex-end; /* bottom align */
  justify-content: flex-end;
  white-space: nowrap;
}

.tariff-alert .tariff-text {
  font-family: var(--f-primary-bold);
  font-size: var(--base-font-size);
  color: var(--primary-color-0) !important;
}

.tariff-alert h2.tariff-text-price {
  font-family: var(--f-primary-bold);
  color: var(--primary-color-0) !important;
  margin: 0;
}

.card {
  .tariff-alert .tariff-row {
    flex-direction: column;
    gap: 16px;
  }
  .tariff-alert .tariff-col-price {
    align-self: flex-end;
  }
}

.card--xs {
  .tariff-alert .tariff-col-price {
    align-self: flex-start;
  }
}

.icon {
  color: var(--secondary-color-0);
}
</style>
